module.exports = __webpack_public_path__ + "static/img/40019 (5).23b94ab.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/40000/40019 (5).webp
// module id = hBxT
// module chunks = 14